import React, { useState } from 'react';
import './css/Contact.css'; // Dedicated page styles

// Reusing your standalone, modular layout components
import Navbar from './components/Navbar';
import Newsletter from './components/NewsLetter';
import Footer from './components/Footer';

// Reusing your global hero and banner background assets
import contactHeroBg from '../images/HomeBgBanner.png';
import DownloadApp from './components/DownloadApp';

function Contact() {
    // Optional form state handling for future interactivity
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Handle form submission logic here
        console.log('Form submitted:', formData);
    };

    return (
        <div className="contact-page-wrapper">

            {/* 1. Header Hero Section with integrated clean Navbar */}
            <section
                className="contact-hero-section"
                style={{ backgroundImage: `url(${contactHeroBg})` }}
            >
                <Navbar />
            </section>

            {/* 2. Contact Section Core Layout */}
            <section className="contact-main-section">
                <div className="container">

                    {/* Centralized Section Header */}
                    <div className="row justify-content-center text-center mb-5">
                        <div className="col-lg-8">
                            <span className="contact-section-mini-tag">Get In Touch</span>
                            <h2 className="contact-section-heading">Let's Build Something Exceptional</h2>
                            <p className="contact-section-subtext mt-3">
                                Have questions regarding our modular UI architecture or custom design-token integration systems? Drop us a message below.
                            </p>
                            <div className="zigzag-border mx-auto mt-3"></div>
                        </div>
                    </div>

                    <div className="row g-5 justify-content-center">

                        {/* Left Column: Contact Form */}
                        <div className="col-lg-7">
                            <div className="contact-glass-form-card">
                                <form onSubmit={handleSubmit}>
                                    <div className="row g-4">

                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="form-label-custom">Your Name</label>
                                                <input
                                                    type="text"
                                                    name="name"
                                                    className="form-control custom-input-field"
                                                    placeholder="John Doe"
                                                    value={formData.name}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="form-label-custom">Email Address</label>
                                                <input
                                                    type="email"
                                                    name="email"
                                                    className="form-control custom-input-field"
                                                    placeholder="john@example.com"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-12">
                                            <div className="form-group">
                                                <label className="form-label-custom">Subject</label>
                                                <input
                                                    type="text"
                                                    name="subject"
                                                    className="form-control custom-input-field"
                                                    placeholder="Project Inquiry / Modular Integration"
                                                    value={formData.subject}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-12">
                                            <div className="form-group">
                                                <label className="form-label-custom">Your Message</label>
                                                <textarea
                                                    name="message"
                                                    rows="5"
                                                    className="form-control custom-input-field"
                                                    placeholder="Tell us about your project requirements..."
                                                    value={formData.message}
                                                    onChange={handleChange}
                                                    required
                                                ></textarea>
                                            </div>
                                        </div>

                                        <div className="col-12 text-end">
                                            <button type="submit" className="contact-submit-btn">
                                                Send Message
                                            </button>
                                        </div>

                                    </div>
                                </form>
                            </div>
                        </div>

                        {/* Right Column: Direct Info / Branding Panel */}
                        <div className="col-lg-4">
                            <div className="contact-info-glass-card">
                                <h3>Contact Information</h3>
                                <div className="zigzag-border mb-4"></div>
                                {/* <p className="info-desc">
                                    Reach out directly through our registered corporate locations or operational engineering hubs below.
                                </p> */}

                                <ul className="contact-details-list">
                                    {/* <li>
                                        <span className="info-label">Registered Office:</span>
                                        <span className="info-value">
                                            F 201 Raheja Heights,<br />
                                            Gen. A. K. Vaidya Marg,<br />
                                            Malad East, Mumbai-400 097
                                        </span>
                                    </li> */}
                                    <li>
                                        <span className="info-label">Operating Office:</span>
                                        <span className="info-value">
                                            1/23 Vivek Nagar, Jheel Road,<br />
                                            Kolkata-700 075
                                        </span>
                                    </li>
                                    {/* Embedded Google Map Section for Operating Office */}
                                    <div className="map-container-wrapper">
                                        <div className="map-container-wrapper">
                                            <iframe
                                                title="Crestest Kolkata Office Map"
                                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3686.119184977014!2d88.37273767428478!3d22.499711035639823!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a0271b52d0e0a2b%3A0x8db289bb935bbf55!2sCrestest%20Learning%20Ventures%20LLP%20%3A%20Online%20Learning%20Portal%20for%20CBSE%20%26%20ICSE%20Board%20Students!5e0!3m2!1sen!2sin!4v1784986987007!5m2!1sen!2sin"
                                                width="100%"
                                                height="180"
                                                style={{ border: 0 }}
                                                allowFullScreen=""
                                                loading="lazy"
                                                referrerPolicy="strict-origin-when-cross-origin"
                                            ></iframe>
                                        </div>

                                    </div>
                                    <li>
                                        <span className="info-label">Direct Email:</span>
                                        <span className="info-value">info@crestest.com</span>
                                    </li>
                                    <li>
                                        <span className="info-label">Direct Phone:</span>
                                        <span className="info-value">+91 6289 581 169</span>
                                    </li>
                                </ul>



                            </div>
                        </div>

                    </div>

                </div>
            </section>

            {/* Download App Section */}
            <DownloadApp />

            {/* 3. Reusable Global Bottom Components */}
            <Newsletter />
            <Footer />

        </div>
    );
}

export default Contact;